// extracted by mini-css-extract-plugin
module.exports = {"table":"_1wup6GwNSoR8swKpgavIAr"};